<template>
	<div class='lmAes-rag'>
    <h2>MoPaaS 大模型应用引擎：RAG（Falcon）</h2>
    <div class="box">
      <img src="../../assets/images/lmaesRag.png"/>
      </div>
	</div>
</template>

<script>
	export default {
		name: 'LmAesRag'
	}
</script>

<style scoped>
    .lmAes-rag {
      background: #ffffff;
      padding: 4.16vw 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .lmAes-rag h2 { 
      max-width: 80vw;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #3963B3;
      line-height: 24px;
      text-align: center;
      font-style: normal;
    }
    .lmAes-rag .box {
      width: 100%;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lmAes-rag .box img {
      width: 76.38vw;
      height: 37.91vw;
    }
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/LmAesRag.vue